import React from 'react';

import { classNames } from '@/utils/classNames.utils';

interface SixDetailSectionHeaderProps {
  title: string;
  countLabel: string;
  action?: React.ReactNode;
  className?: string;
}

export default function SixDetailSectionHeader({
  title,
  countLabel,
  action,
  className,
}: SixDetailSectionHeaderProps) {
  return (
    <div
      className={classNames(
        'flex flex-col sm:flex-row sm:items-center sm:justify-between',
        'space-y-3 sm:space-y-0',
        className
      )}
    >
      <div className="flex items-center space-x-2 sm:space-x-4">
        <h2 className="text-lg font-semibold">{title}</h2>
        <div className="inline-flex items-center rounded-full border px-2.5 py-0.5 text-xs font-semibold transition-colors focus:outline-none focus:ring-2 focus:ring-ring focus:ring-offset-2 text-foreground">
          {countLabel}
        </div>
      </div>

      {action}
    </div>
  );
}
